"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { compareQueryFromIds, readCompareCarIds } from "@/lib/compare-cars";

/** Если открыли /cars/compare без ids, но в сравнении уже ≥ 2 авто — подставляем список из localStorage. */
export default function CompareRedirectFromStorage() {
  const router = useRouter();
  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    if (q.get("ids")) return;
    const stored = readCompareCarIds();
    if (stored.length >= 2) {
      router.replace(`/cars/compare?ids=${compareQueryFromIds(stored)}`);
    }
  }, [router]);
  return null;
}
